import sparkles_auth from './images/sparkles_auth.svg';
import auth_video from './videos/auth_video.mp4'
import walid_pic from './images/me.png'

const MEDIAS = {
    sparkles_auth,
    auth_video,
    walid_pic
}

export { MEDIAS };
